import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { photosDesign } from "../../../script";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllProjects.css";

export default function Design3d() {
  
  const location = useLocation();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "3d Design Project | BUR-HAN Garden & Lawn Care";
    document.title = newTitle;

    const newDescription =
    "Discover our upcoming 3D design projects and how we bring landscapes to life through immersive 3D designs. Stay tuned for realistic visual representations of landscaping projects before any work begins.";
    const descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
 "3D landscape design Vancouver",
  "landscape rendering Vancouver",
  "3D garden visualization",
  "outdoor design models",
  "landscape planning Vancouver",
  "custom 3D landscape projects",
  "yard design rendering",
  "landscape concept visualization"    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <div className="wrapper">
      <Header />

      <div className="projectsGalleryHeader">
        <h1 data-aos="zoom-in"> 3D Design</h1>
      </div>
      <div className="projectsGalleryMain" data-aos="fade-up">
        <h2 className="text-center">
          {" "}
          <a href="/services/design-and-modelling">
            Click here to learn more about our services{" "}
          </a>
        </h2>
        <hr />

        <a href="/our-projects" className="to-top">
          Back to projects
        </a>

        <div className="gallery">
          <Gallery photos={photosDesign} onClick={openLightbox} />
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={photosDesign.map((x) => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                    alt: x.alt,
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
        <section className="project-text" data-aos="fade-up">
          <div className="container">
            <h2>3D Landscape Design in Vancouver & North Shore</h2>
            <p>
              Planning an outdoor renovation in Vancouver, North Vancouver, or
              West Vancouver? Our <strong>3D landscape design service</strong>{" "}
              lets you see your finished yard before any work begins. At{" "}
              <strong>BUR-HAN Garden & Lawn Care</strong>, we create detailed,
              photorealistic renderings of your property — including patios,
              retaining walls, garden beds, lawn areas, and plantings — so you
              can visualize every detail and make confident decisions about your
              investment.
            </p>
            <p>
              Our landscape design process starts with a full site visit and
              consultation. We assess your property, discuss your goals, and
              build a 3D model that reflects exactly what your outdoor space
              could look like. Whether you're planning a complete backyard
              transformation, a new paving stone patio, or a front yard
              redesign, the 3D visualization removes all guesswork and helps
              avoid costly changes mid-construction.
            </p>
            <p>
              Homeowners across Greater Vancouver consistently tell us that
              seeing a realistic 3D rendering of their landscape design made the
              renovation process far less stressful and much more exciting.
              Being able to review materials, layouts, and plant choices before
              the project breaks ground is something every homeowner deserves.
            </p>
            <p>
              Browse the 3D design gallery above to get inspired, then{" "}
              <a href="/contact-us">contact our team</a> to schedule your
              landscape design consultation. From concept to completion,
              BUR-HAN delivers outdoor spaces that are built to last and
              designed to impress.
            </p>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-8 ">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>
                  Fill out our Get a Quote page, and let our expert landscaping
                  team bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs. Contact us today to get a personalized landscaping plan tailored to your needs. Your dream garden is just one step away.
                </p>
              </div>
              <div className="col-md-4 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Get A Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
